"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPhoneNumber = void 0;

var _googleLibphonenumber = _interopRequireDefault(require("google-libphonenumber"));

var _loglevel = _interopRequireDefault(require("loglevel"));

var _lib$PhoneNumberForma = _googleLibphonenumber.default.PhoneNumberFormat,
    NATIONAL = _lib$PhoneNumberForma.NATIONAL,
    INTERNATIONAL = _lib$PhoneNumberForma.INTERNATIONAL;

var PhoneNumberUtil = _googleLibphonenumber.default.PhoneNumberUtil.getInstance();

var MODULE_NAME = 'sdk/utils/formatPhoneNumber';

var logger = _loglevel.default.getLogger(MODULE_NAME);

var formatPhoneNumber = function formatPhoneNumber(phoneNumber) {
  var countryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  // handle null countryCode
  var browserCountryCode;
  if (window && window.navigator && window.navigator.language) browserCountryCode = window.navigator.language.split('-')[1];
  var cc = countryCode || browserCountryCode || 'US';
  logger.info("".concat(MODULE_NAME, " - formatPhoneNumber called"), phoneNumber, cc);

  if (!phoneNumber) {
    return '';
  } // 7 digit formatting


  if (phoneNumber.trim().replace(/\D/g, '').length === 7) {
    return "".concat(phoneNumber.slice(0, 3), "-").concat(phoneNumber.slice(3));
  } // format with region code


  try {
    var parsed = PhoneNumberUtil.parseAndKeepRawInput(phoneNumber, cc);

    if (PhoneNumberUtil.isPossibleNumber(parsed) && PhoneNumberUtil.isValidNumber(parsed) && PhoneNumberUtil.isValidNumberForRegion(parsed, cc)) {
      return PhoneNumberUtil.format(parsed, NATIONAL);
    } else if (PhoneNumberUtil.isPossibleNumber(parsed) && PhoneNumberUtil.isValidNumber(parsed)) {
      return PhoneNumberUtil.format(parsed, INTERNATIONAL);
    }

    return phoneNumber;
  } catch (err) {
    logger.debug("".concat(MODULE_NAME, " - formatPhoneNumber err"), err);
    return phoneNumber;
  }
};

exports.formatPhoneNumber = formatPhoneNumber;